import { SvgIcon, SvgIconProps } from "@mui/material";

const RmbgIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 17 17" {...props}>
			<path
				d="M3.125 0.625L0.625 3.125M15.625 13.125L13.125 15.625M7.29167 0.625L0.625 7.29167M11.4583 0.625L0.625 11.4583M15.625 0.625L0.625 15.625M15.625 4.79167L4.79167 15.625M15.625 8.95833L8.95833 15.625"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};

export default RmbgIcon;
